<template>
  <div id="gasTempChart">
    <div id="gasTempchartBox" ref="gasTempChartBox"></div>
  </div>
</template>
<script>
import echarts from "echarts/lib/echarts";
// 引入折线图
import "echarts/lib/chart/line";
import "echarts/lib/component/title";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/dataZoom";
export default {
  name: "gasTempChart",
  data() {
    return {
      xData: [],
      gasData: [],
      envTemps: [],
    };
  },
  props: {
    chartData: null,
    equipmentData: null,
    chartIndex: 0,
  },
  created() {
    for (let i = 0; i <= 24; i++) {
      this.xData.push(i);
    }
  },
  mounted() {
    var chartItemData = this.chartData;
    chartItemData.gasQuantity.forEach((element) => {
      this.gasData.push(element.gasQuantity);
    });
    if (this.equipmentData != null) {
      var temps = this.equipmentData.temps;
      var selDateStr = this.equipmentData.temps[0].dateTime;
      var nowSelectedDateStr = selDateStr.split(" ")[0].replace('/-/g', '/') + " 00:00:00";
      var selDate = Date.parse(nowSelectedDateStr);
      for (let i = 0; i <= 24; i++) {
        for (let j = 0; j < temps.length; j++) {
          var itemTemp = temps[j];
          var itemTime = Date.parse(itemTemp.dateTime.replace('/-/g', '/'));
          var poor = Math.abs(itemTime - selDate);
          if (poor < 10000) {
            this.envTemps.push(itemTemp.outDoorTemp);
            break;
          }
        }
        selDate = selDate + 60 * 60 * 1000;
      }
    }
    setTimeout(() => {
      this.myChart = echarts.init(this.$refs.gasTempChartBox);
      this.initData();
    }, 500);
  },
  methods: {
    initData() {
      var option = {
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            var paramGas = params[0];
            var paramTemp = params[1];
            if (paramGas == undefined || paramTemp == undefined) {
              return "";
            }
            var axisLabel = parseInt(paramGas.axisValue);
            if (axisLabel.length == 1) {
              axisLabel = "0" + axisLabel;
            }
            var axisDate = axisLabel + ":" + "00";
            var gasData = paramGas.data == null ? "-" : paramGas.data;
            var tempData = paramTemp.data == null ? "-" : paramTemp.data;
            return (
              axisDate +
              "</br>" +
              paramGas.marker +
              paramGas.seriesName +
              ": " +
              gasData +
              "</br>" +
              paramTemp.marker +
              paramTemp.seriesName +
              ": " +
              tempData
            );
          },
        },
        textStyle: {
          color: "#E3EAF3",
        },
        grid: {
          top: "20%",
          left: "20%",
          right: "15%",
          bottom: "22%",
          containLabel: false,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
          name: "时间(h)",
          nameLocation: "start",
          nameTextStyle: {
            fontSize: 10,
            fontWeight: 10,
            align: "center",
            verticalAlign: "top",
            padding: [8, 10, 0, 0],
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            interval: 1,
            textStyle: {
              fontSize: 10,
              fontWeight: 10,
            },
          },
        },
        yAxis: [
          {
            type: "value",
            name: "温度(℃)",
            offset: 10,
            nameTextStyle: {
              fontSize: 10,
              fontWeight: 10,
              align: "center",
              padding: [0, 20, 0, 0],
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                fontSize: 10,
                fontWeight: 10,
              },
            },
          },
          {
            type: "value",
            name: "气量(m³)",
            nameTextStyle: {
              fontSize: 10,
              fontWeight: 10,
              align: "left",
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                fontSize: 10,
                fontWeight: 10,
              },
            },
          },
        ],
        dataZoom: [
          {
            type: "inside",
            show: false,
            xAxisIndex: [0],
            height: 1,
            start: 1,
            end: 100,
          },
        ],
        series: [
          {
            name: "气量",
            type: "line",
            symbol: "circle",
            yAxisIndex: 1,
            itemStyle: {
              color: "#E4640F",
            },
            lineStyle: {
              color: "#E4640F",
            },
            data: this.gasData,
          },
          {
            name: "温度",
            type: "line",
            symbol: "circle",
            yAxisIndex: 0,
            itemStyle: {
              color: "#4BCEFF",
            },
            lineStyle: {
              color: "#4BCEFF",
            },
            data: this.envTemps,
          },
        ],
      };
      this.myChart.setOption(option);
    },
  },
};
</script>
<style scoped>
#gasTempChart {
  width: 100%;
  height: 100%;
}
#gasTempchartBox {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/subComponents/smartGasTempChart.vue